import storeActions from '../storeActions';

export default function deviceStorageReducer(state, { type, payload = null }) {
    switch (type) {
        case storeActions.initState:
            return {
                ...payload
            };
        case storeActions.setLanguage:
            return {
                ...state,
                language: payload
            };
        case storeActions.setAspectRatio:
            return {
                ...state,
                aspectRatio: payload
            };
        case storeActions.setVideoQualityProfile:
            return {
                ...state,
                videoQualityProfile: payload
            };
        case storeActions.setDownloadProfile:
            return {
                ...state,
                downloadProfile: payload
            };
        case storeActions.setShowMobileNetworkWarning:
            return {
                ...state,
                showMobileNetworkWarning: payload
            };
        case storeActions.setVideoStreamingOverCellular:
            return {
                ...state,
                videoStreamingOverCellular: payload
            };
        case storeActions.setDownloadsOverCellular:
            return {
                ...state,
                downloadsOverCellular: payload
            };
        case storeActions.setAutoParentalLockInterval:
            return {
                ...state,
                autoParentalLockInterval: payload
            };
        case storeActions.setAutoPlayNextItem:
            return {
                ...state,
                autoPlayNextItem: payload
            };
        case storeActions.setRememberPassword:
            return {
                ...state,
                rememberPassword: payload
            };
        case storeActions.setOnboardingCompleted:
            return {
                ...state,
                onboardingCompleted: payload
            };
        case storeActions.setShowEnforceChangePassword:
            return {
                ...state,
                showEnforceChangePassword: payload
            };
        case storeActions.setParentalControlLocked:
            return {
                ...state,
                parentalControlLocked: payload
            };
        case storeActions.setCookieConsent:
            return {
                ...state,
                cookieConsentGiven: Boolean(payload)
            };
        case storeActions.setEpgSelectedListMode:
            return {
                ...state,
                epgSelectedListMode: payload
            };
        case storeActions.setDataSaverValue:
            return {
                ...state,
                dataSaverValue: payload
            };
        case storeActions.setPlayerVolume:
            return {
                ...state,
                playerVolume: payload
            };
        case storeActions.setIsNewFeaturesChecked:
            return {
                ...state,
                isNewFeaturesChecked: payload
            };
        default:
            return state;
    }
}
